import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, TextField, Divider } from "@material-ui/core";
import Axios from "axios";
import Pagination from "@material-ui/lab/Pagination";

import { url } from "../../../../config/config";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./BookBy.css";

class BookByAuthor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authors: [],
      search: {
        fullName: "",
      },
      currentPage: 1,
      postPerPage: 10,
      isEmpty: true,
    };
  }

  async componentDidMount() {
    const response = await Axios.get(`${url}/api/authors`);
    if (response.data.length !== 0) {
      this.setState({
        authors: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        authors: [],
        isEmpty: true,
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  compare = (a, b) => {
    const nameA = a.firstName.toUpperCase();
    const nameB = b.firstName.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  handleClick = (authorId) => {
    this.props.history.push(`/books/category/author/${authorId}`);
  };

  render() {
    const { classes } = this.props;
    const { currentPage, postPerPage } = this.state;
    const filtered = this.state.authors.filter((author) => {
      let authorName = author.firstName + " " + author.lastName;
      return (
        authorName
          .toLowerCase()
          .indexOf(this.state.search.fullName.toLowerCase()) !== -1
      );
    });
    filtered.sort(this.compare);
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div className={classes.buttonRoot}>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
              onClick={() => this.props.history.push(`/books/category/author`)}
            >
              Browse Book By Author
            </Button>
            <Button
              disableRipple
              variant="outlined"
              className={classes.buttonStyle}
              onClick={() => this.props.history.push(`/books/category/genre`)}
            >
              Browse Book By Genre
            </Button>
          </div>
          <div
            style={{
              padding: 10,
              fontSize: 30,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Category by Author
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              name="fullName"
              type="text"
              fullWidth
              label="Author's Name"
              variant="outlined"
              style={{ marginRight: 15 }}
              placeholder="Search by author's Name"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.nameInputStyle}
              value={this.state.search.fullName}
              onChange={this.handleChange}
            />
          </div>

          <br />
          <Divider />
          {this.state.authors.length !== 0 ? (
            <div
              style={{
                padding: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container spacing={3} style={{ width: "100%" }}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  xl={6}
                  lg={6}
                  className={classes.gridStyle}
                >
                  <div
                    className={classes.labelStyle}
                    onClick={() => this.handleClick("All")}
                  >
                    All
                  </div>
                </Grid>
                {filtered.map((author, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    xl={6}
                    lg={6}
                    key={index}
                    className={classes.gridStyle}
                  >
                    <div
                      className={classes.labelStyle}
                      onClick={() => this.handleClick(author._id)}
                    >
                      {author.firstName} {author.lastName}
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : this.state.isEmpty === false ? (
            <CustomEmptyMessage message="There is no any book published by this author." />
          ) : (
            <CustomLoader />
          )}
          <div className={classes.paginationStyle}>
            <Pagination
              count={Math.ceil(filtered.length / postPerPage)}
              color="secondary"
              page={currentPage}
              boundaryCount={1}
              onChange={this.handlePage}
              showFirstButton
              showLastButton
            />
          </div>
          <br />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(BookByAuthor));
